import { render, staticRenderFns } from "./StatutEtatBlock.vue?vue&type=template&id=21588b86&scoped=true"
import script from "./StatutEtatBlock.vue?vue&type=script&lang=ts"
export * from "./StatutEtatBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21588b86",
  null
  
)

export default component.exports